const OTHER_INFORMAL_LIABILITY_REASON = 367;
const OTHER_CREDIT_REASON = 72;
const YEARS = (MIN, MAX) => Array.from({ length: MAX - MIN + 1 }, (v, k) => k + MIN);

export default {
    OTHER_INFORMAL_LIABILITY_REASON,
    OTHER_CREDIT_REASON,
    YEARS
};
